export default {
  reviews: [],
  loading: false,
}
